// Reusable dashboard header quick-actions row. Ships a prominent 'My Profile' + 'Newsfeed'
// button set into every internal dashboard (Studio, CreatorHQ, OwnerHQ, StaffConsole, SponsorHQ, BReels).
// Keeps profile access one tap away from every place a signed-in user might land.
import { Link } from "react-router-dom";
import { User as UserIcon, Newspaper, Rss, Megaphone, Crown, Settings as SettingsIcon, Wallet } from "lucide-react";
import { useAuth } from "../lib/auth";

export default function DashboardQuickActions({ className = "" }) {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <div className={`flex flex-wrap items-center gap-1.5 ${className}`} data-testid="dashboard-quick-actions">
      <Link
        to={`/u/${user.id}`}
        data-testid="dashboard-my-profile"
        className="inline-flex items-center gap-1.5 rounded-full bg-white/5 hover:bg-nexus-cyan/15 hover:text-nexus-cyan text-white/80 px-3 py-1.5 text-[10px] tracking-[0.25em] uppercase font-display border border-white/10 transition-colors"
      >
        <UserIcon className="w-3 h-3" /> My Profile
      </Link>
      <Link
        to="/feed"
        data-testid="dashboard-newsfeed"
        className="inline-flex items-center gap-1.5 rounded-full bg-white/5 hover:bg-nexus-mint/15 hover:text-nexus-mint text-white/80 px-3 py-1.5 text-[10px] tracking-[0.25em] uppercase font-display border border-white/10 transition-colors"
      >
        <Newspaper className="w-3 h-3" /> Newsfeed
      </Link>
      <Link
        to={`/u/${user.id}?tab=posts`}
        data-testid="dashboard-my-posts"
        className="inline-flex items-center gap-1.5 rounded-full bg-white/5 hover:bg-nexus-gold/15 hover:text-nexus-gold text-white/80 px-3 py-1.5 text-[10px] tracking-[0.25em] uppercase font-display border border-white/10 transition-colors"
      >
        <Rss className="w-3 h-3" /> My Posts
      </Link>
      <Link
        to="/business"
        data-testid="dashboard-business"
        className="inline-flex items-center gap-1.5 rounded-full bg-white/5 hover:bg-nexus-magenta/15 hover:text-nexus-magenta text-white/80 px-3 py-1.5 text-[10px] tracking-[0.25em] uppercase font-display border border-white/10 transition-colors"
      >
        <Megaphone className="w-3 h-3" /> Business
      </Link>
      <Link
        to="/wallet"
        data-testid="dashboard-wallet"
        className="inline-flex items-center gap-1.5 rounded-full bg-white/5 hover:bg-nexus-gold/15 hover:text-nexus-gold text-white/80 px-3 py-1.5 text-[10px] tracking-[0.25em] uppercase font-display border border-white/10 transition-colors"
      >
        <Wallet className="w-3 h-3" /> Wallet
      </Link>
      <Link
        to="/settings"
        data-testid="dashboard-settings"
        className="inline-flex items-center gap-1.5 rounded-full bg-white/5 hover:bg-white/15 hover:text-white text-white/80 px-3 py-1.5 text-[10px] tracking-[0.25em] uppercase font-display border border-white/10 transition-colors"
      >
        <SettingsIcon className="w-3 h-3" /> Settings
      </Link>
      {user.role === "owner" && (
        <Link
          to="/owner"
          data-testid="dashboard-owner-hq"
          className="inline-flex items-center gap-1.5 rounded-full bg-nexus-amber/10 hover:bg-nexus-amber/25 text-nexus-amber px-3 py-1.5 text-[10px] tracking-[0.25em] uppercase font-display border border-nexus-amber/30 transition-colors"
        >
          <Crown className="w-3 h-3" /> Owner HQ
        </Link>
      )}
    </div>
  );
}
